import { Button } from '@smartgift/frontend-toolkit';
import styled, { css } from 'styled-components';

import { DEVICE } from '@hero/constants';

const SignInTemplate = styled.div`
  background-color: var(--color-bg-default);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  display: flex;
  margin: 0 auto;
  width: 458px;

  ${({ hasMultipleRows }) =>
    hasMultipleRows &&
    css`
      width: 916px;
    `}

  ${DEVICE.tablet.mid} {
    width: 458px;
    flex-direction: column;
  }
  ${DEVICE.mobile.max} {
    flex-direction: column;
    width: 100%;
  }
`;

const SignInContentFooter = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  margin-top: 8px;
`;

const SignUpWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-16);
`;

const SignInContentNote = styled.div`
  background-color: var(--color-bg-weaker);
  color: var(--color-fg-weaker);
  margin-top: auto;
  padding: 8px 12px;
  text-align: left;

  ${DEVICE.mobile.max} {
    margin-top: 12px;
  }

  a {
    color: var(--color-fg-weaker);
    text-decoration: underline;
  }
`;

const SignInContent = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 40px;
  width: 100%;

  ${DEVICE.mobile.max} {
    padding: 24px;
  }
`;

const SignInEmailContent = styled.div`
  height: 100%;
  padding: 24px;
  width: 458px;
`;

const SignInContentBody = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--size-gap-24);
  padding-top: 4px;
`;

const PublicLoginDisabledWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 24px;
  width: 100%;
`;

const SignInCard = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${Button?.S?.Button} {
    margin: 16px 0 24px 0;
  }
`;

export {
  PublicLoginDisabledWrapper,
  SignInCard,
  SignInContent,
  SignInContentBody,
  SignInContentFooter,
  SignInContentNote,
  SignInEmailContent,
  SignInTemplate,
  SignUpWrapper
};
